import { useState } from "react";
import { CalendarDays, ListOrdered } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePlanMode, PlanMode } from "../hooks/usePlanMode";
import { SequentialOrderDialog } from "./SequentialOrderDialog";

interface PlanModeToggleProps {
  planId: string;
  mode: PlanMode;
  canEdit: boolean;
  routines: any[];
}

export const PlanModeToggle = ({ planId, mode, canEdit, routines }: PlanModeToggleProps) => {
  const { setMode } = usePlanMode(planId);
  const [orderDialogOpen, setOrderDialogOpen] = useState(false);

  if (!canEdit) {
    return (
      <div className="inline-flex items-center gap-2 rounded-full border border-primary/20 bg-card px-3 py-1.5 text-xs text-primary/80">
        {mode === "sequential" ? (
          <>
            <ListOrdered className="h-3.5 w-3.5" />
            Modo secuencial
          </>
        ) : (
          <>
            <CalendarDays className="h-3.5 w-3.5" />
            Modo por días
          </>
        )}
      </div>
    );
  }

  const handleSequentialClick = () => {
    if (mode === "sequential") return;
    // Open dialog so user defines the order; on confirm we activate sequential mode.
    setOrderDialogOpen(true);
  };

  return (
    <>
      <div className="inline-flex items-center rounded-full border border-primary/20 bg-card p-1">
        <Button
          size="sm"
          variant={mode === "days" ? "default" : "ghost"}
          onClick={() => mode !== "days" && setMode.mutate("days")}
          disabled={setMode.isPending}
          className="h-7 rounded-full px-3 text-xs"
        >
          <CalendarDays className="mr-1.5 h-3.5 w-3.5" />
          Por días
        </Button>
        <Button
          size="sm"
          variant={mode === "sequential" ? "default" : "ghost"}
          onClick={handleSequentialClick}
          disabled={setMode.isPending}
          className="h-7 rounded-full px-3 text-xs"
        >
          <ListOrdered className="mr-1.5 h-3.5 w-3.5" />
          Secuencial
        </Button>
      </div>

      <SequentialOrderDialog
        open={orderDialogOpen}
        onOpenChange={setOrderDialogOpen}
        routines={routines}
        planId={planId}
        activateModeOnConfirm
      />
    </>
  );
};
